module.exports = __webpack_public_path__ + "img/RegFees-6-courses.4383ae4b.svg";